import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/content';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[580px] md:h-[680px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20cinematic%20abstract%20background%20with%20warm%20gradient%20tones%20of%20deep%20red%20amber%20and%20soft%20cream%2C%20subtle%20film%20grain%20texture%2C%20elegant%20theatrical%20lighting%20effect%2C%20minimalist%20composition%2C%20Japanese%20and%20Korean%20cinema%20aesthetic%20inspiration%2C%20clean%20sophisticated%20design%20with%20dramatic%20contrast&width=1800&height=900&seq=hero-bg-main-2024&orientation=landscape"
        alt="日韩影视中文字幕导航"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/55"></div>

      <div className="relative z-10 w-full max-w-[900px] mx-auto px-4 md:px-8 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20 mb-6">
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-sparkling-2-fill text-accent-400 text-xs"></i>
          </div>
          <span className="text-xs text-background-50/90 font-medium whitespace-nowrap">
            专注中文字幕日韩影视资源导航
          </span>
        </div>

        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-6 leading-tight">
          {siteInfo.tagline}
        </h1>

        <p className="text-base md:text-lg text-background-50/70 max-w-[650px] mx-auto mb-10 leading-relaxed">
          {siteInfo.description}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/jdrama"
            className="whitespace-nowrap px-8 py-3.5 rounded-lg bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors cursor-pointer w-full sm:w-auto text-center"
          >
            浏览日韩剧
            <div className="w-4 h-4 inline-flex items-center justify-center ml-1.5">
              <i className="ri-arrow-right-line text-xs"></i>
            </div>
          </Link>
          <a
            href="#platform-comparison"
            className="whitespace-nowrap px-8 py-3.5 rounded-lg bg-background-50/10 backdrop-blur-sm border border-background-50/30 text-background-50 font-semibold text-sm hover:bg-background-50/20 transition-colors cursor-pointer w-full sm:w-auto text-center"
          >
            查看平台对比
            <div className="w-4 h-4 inline-flex items-center justify-center ml-1.5">
              <i className="ri-arrow-down-line text-xs"></i>
            </div>
          </a>
        </div>

        <div className="mt-12 flex items-center justify-center gap-8">
          {[
            { value: '200+', label: '日韩影视作品' },
            { value: '6', label: '平台对比评测' },
            { value: '50万+', label: '月活跃追剧用户' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-background-50">
                {stat.value}
              </div>
              <div className="text-xs text-background-50/60 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}